import { setInstitutions } from './dispatchers';
import { dataMultiLoader } from '../../web/utilities/dataLoader';

export function initialise(dispatch) {
  const initialInstitutionsDataObjects = dataMultiLoader('redux-institutions');
  initialInstitutionsDataObjects.map((initialInstitutionsData) => {
    return dispatch(setInstitutions(Object.values(initialInstitutionsData)));
  });
}
